class NgConfig {
    static UPLOAD_URL = '/api/userfiles/'
    static JOB_START_URL = '/api/jobs/start/'
    static JOB_STATUS_URL = '/api/jobs/status/'
    static FILES_URL = '/userfiles'
    static PARAMS_URL = '/tools/params'
    static FILES_API_URL = '/api/userfiles'
    static MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 1024
    static MAX_NUMBER_OF_BATCH_UPLOADS = 10
}

export default NgConfig